// extracted by mini-css-extract-plugin
module.exports = {"nav":"r9pZ5","container":"sgvDi","content":"AtrZi","loader":"pQytV"};